import type { SVGProps } from 'react';

/** Small inline glyphs the components need (16px grid, currentColor). App icons come from lucide. */
type P = SVGProps<SVGSVGElement> & { size?: number };
const base = (size = 16): SVGProps<SVGSVGElement> => ({
  width: size,
  height: size,
  viewBox: '0 0 16 16',
  'aria-hidden': true,
  focusable: false,
});

export const CheckGlyph = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}>
    <path d="M6.5 11.2 3.3 8l-1 1 4.2 4.2 7.2-7.2-1-1z" fill="currentColor" />
  </svg>
);

export const DashGlyph = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}>
    <path d="M4 7.25h8v1.5H4z" fill="currentColor" />
  </svg>
);

export const CloseGlyph = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}>
    <path
      d="m8 7 4.5-4.5 1 1L9 8l4.5 4.5-1 1L8 9l-4.5 4.5-1-1L7 8 2.5 3.5l1-1z"
      fill="currentColor"
    />
  </svg>
);

/** The filled caret used by selects and split buttons. */
export const CaretGlyph = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}>
    <path d="M4.5 6.5h7L8 10.5z" fill="currentColor" />
  </svg>
);

/**
 * The default person silhouette (filled head and shoulders) of avatars without a photo (cui5-avatar: the person
 * glyph at 75% of the circle; person-detail.jpg, deals-pipeline.jpg). BOLTcrm's own drawing.
 */
export const PersonGlyph = ({ size, ...p }: P) => (
  <svg {...base(size)} {...p}>
    <circle cx="8" cy="5.25" r="3.25" fill="currentColor" />
    <path d="M2 15.5a6 6 0 0 1 12 0z" fill="currentColor" />
  </svg>
);

/**
 * A checkered flag (the deal Summary's expected close date, deal-detail.jpg). Drawn on lucide's 24px grid with a
 * 2px stroke so it sits with the lucide icons around it; lucide has no checkered flag. BOLTcrm's own drawing.
 */
export const CheckeredFlagIcon = ({ size = 16, ...p }: P) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    focusable={false}
    {...p}
  >
    <path d="M4 22V3" />
    <rect x="4" y="3" width="16" height="12" rx="1" />
    <path
      d="M8 3h4v4H8zM16 3h4v4h-4zM4 7h4v4H4zM12 7h4v4h-4zM8 11h4v4H8zM16 11h4v4h-4z"
      fill="currentColor"
      stroke="none"
    />
  </svg>
);
